/**
 * Типы для модуля статистики Instagram
 */

export type MediaContentType = 'IMAGE' | 'VIDEO' | 'CAROUSEL_ALBUM' | 'REELS';

export type ContentTypeLabel = 'Пост' | 'Рилс' | 'Карусель' | 'Видео';

export const CONTENT_TYPE_LABELS: Record<MediaContentType, ContentTypeLabel> = {
  IMAGE: 'Пост',
  VIDEO: 'Видео',
  CAROUSEL_ALBUM: 'Карусель',
  REELS: 'Рилс',
};

/** Статистика одного медиа */
export type MediaStats = {
  url: string;
  shortcode: string;
  mediaId: string;
  contentType: MediaContentType;
  contentTypeLabel: ContentTypeLabel;
  impressionsInstagram: number;
  impressionsFacebook: number;
  impressionsTotal: number;
  likes: number;
  comments: number;
  shares: number;
  saved: number;
  reach: number;
  crosspostedViews: number;
  igReelsAvgWatchTime: number;
  videoDuration: number;
  skipRate: number;
  accountUsername: string;
  publishedAt: string | null;
  caption: string | null;
  mediaUrl: string | null;
  thumbnailUrl: string | null;
  /** true — данные из Business Discovery (только лайки/комментарии, показы недоступны) */
  isPartial: boolean;
};

/** Медиа с ошибкой получения */
export type MediaStatsError = {
  url: string;
  error: string;
};

/** Запрос на получение статистики */
export type FetchStatsRequest = {
  urls: string[];
  dateFrom?: string;
  dateTo?: string;
};

/** Ответ Edge Function */
export type FetchStatsResponse = {
  results: MediaStats[];
  errors: MediaStatsError[];
  rateLimited: boolean;
  unprocessedUrls: string[];
  apiCallsCount: Record<string, number>;
};

/** Прогресс батчинга */
export type BatchProgress = {
  completedUrls: number;
  totalUrls: number;
  currentBatch: number;
  totalBatches: number;
  percent: number;
};

/** Ключи числовых колонок таблицы */
export type NumericStatsKey =
  | 'impressionsInstagram'
  | 'impressionsFacebook'
  | 'impressionsTotal'
  | 'likes'
  | 'comments'
  | 'shares'
  | 'reach'
  | 'skipRate'
  | 'igReelsAvgWatchTime'
  | 'videoDuration';

/** Описание колонки таблицы */
export type StatsColumn = {
  key: keyof MediaStats;
  label: string;
};

export const STATS_COLUMNS: StatsColumn[] = [
  { key: 'url', label: 'Ссылка' },
  { key: 'contentTypeLabel', label: 'Тип контента' },
  { key: 'publishedAt', label: 'Дата публикации' },
  { key: 'impressionsInstagram', label: 'Показы Instagram' },
  { key: 'impressionsFacebook', label: 'Показы Facebook' },
  { key: 'impressionsTotal', label: 'Всего показов' },
  { key: 'likes', label: 'Лайки' },
  { key: 'comments', label: 'Комментарии' },
  { key: 'shares', label: 'Репосты' },
  { key: 'reach', label: 'Охваты' },
  { key: 'skipRate', label: 'Реакция' },
  { key: 'igReelsAvgWatchTime', label: 'Удержание' },
  { key: 'videoDuration', label: 'Продолжительность' },
];
